import * as React from "react";
import {
    ApolloError,
    gql,
    useMutation,
} from "@apollo/client";
import {
    CreatePartnerExchangeRateMutationMutation,
    CreatePartnerExchangeRateMutationMutationVariables
} from "../../../../../schemaTypes";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";
import { normalizeErrors } from "../../../../../utils/normalizeErrors";

export const createPartnerExchangeRateMutation = gql`
  mutation CreatePartnerExchangeRateMutation(
    $communityId: String!
    $rate: Float!
  ) {
    createPartnerExchangeRate(
      communityId: $communityId
      rate: $rate
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: CreatePartnerExchangeRateMutationMutationVariables
      ) => Promise<{
        errors: NormalizedErrorMap | null;
        message?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

export const CreatePartnerExchangeRateController: React.FC<Props> = ({ children, onMessage }) => {
  const [_createPartnerExchangeRateMutation, { loading, error }] = useMutation<
    CreatePartnerExchangeRateMutationMutation,
    CreatePartnerExchangeRateMutationMutationVariables
  >(createPartnerExchangeRateMutation);

  const submit = async (values: CreatePartnerExchangeRateMutationMutationVariables) => {
    const { data } = await _createPartnerExchangeRateMutation({
      variables: values,
    });

    const errors = data?.createPartnerExchangeRate?.errors
      ? normalizeErrors(data.createPartnerExchangeRate.errors)
      : null;

    if (data?.createPartnerExchangeRate?.message && onMessage) {
      onMessage(data.createPartnerExchangeRate.message);
    }

    return {
      errors,
      message: data?.createPartnerExchangeRate?.message ?? undefined,
    };
  };

  return children({ submit, loading, error });
};
